import {jalaliToGregorian} from '../../../utilities/helper/GetPersianDateTime';
import request from '../../axios';
import {IPostStoreOrderApprovalPayload} from './usePostStoreOrderApproval';

const postStoreOrderApproval = async (
  payload: IPostStoreOrderApprovalPayload,
) => {
  const {orderGuid, supplier_provide_at, ...rest} = payload;

  const formattedPayload = {
    ...rest,
    // replace / with - and do not send anything if there is no supplier_provide_at
    ...(supplier_provide_at
      ? {
          supplier_provide_at: jalaliToGregorian(
            supplier_provide_at.replace(/\//g, '-'),
          ),
        }
      : {}),
  };

  await request.post(
    `/api/v2/order/store-order/approval/${orderGuid}`,
    formattedPayload,
  );
};

export default postStoreOrderApproval;
